
<template>

	<mymodal ref="modal" title="Добавить корректировку" ok="Добавить" :reset="reset" :check="check" :submit="submit" style="overflow-y: none;">

		<b-form-group :state="name_state" label="Наименование" label-for="name" invalid-feedback="Необходимо указать наименование">
			<b-form-input id="name" v-model="data.name" :state="name_state" required/>
		</b-form-group>

		<b-form-group :state="order_state" label="Порядок применения" label-for="order" invalid-feedback="Необходимо указать порядок применения">
			<v-select :options="orders" v-model="data.order" :state="order_state" required appendToBody/>
		</b-form-group>

		<b-form-group :state="type_state" label="Тип" label-for="type" invalid-feedback="Необходимо указать тип">
			<v-select :options="types" v-model="data.type" :state="type_state" required appendToBody/>
		</b-form-group>

		<b-form-group :state="value_state" label="Значение" label-for="value" invalid-feedback="Необходимо указать корректное значение">
			<b-form-input id="value" v-model="data.value" :state="value_state" required type="number"/>
		</b-form-group>

	</mymodal>

</template>

<script>

import api from "../../../../../api"
import mymodal from "../../../../widgets/modal"

export default
{
	props :
	{
		id : String,
	},

	components :
	{
		mymodal,
	},

	data()
	{
		return {

			name_state : null,
			order_state : null,
			type_state : null,
			value_state : null,

			data :
			{
				name : null,
				order : null,
				type : null,
				value : null,
			},

			types : [],
			orders : [],

		}
	},

	beforeMount()
	{
		api.call(this, "cadastral", "get_reference", { reference : "correction_types" }, response => { this.types = response.reference })
	},

	methods :
	{
		check()
		{
			this.name_state = !!this.data.name
			this.order_state = !!this.data.order
			this.type_state = !!this.data.type
			this.value_state = !!this.data.value && ( this.data.type == "Аддитивная" || ( this.data.type == "Мультипликативная" && Number(this.data.value) > 0 ) )

			return this.name_state && this.order_state && this.type_state && this.value_state
		},

		reset()
		{
			this.name_state = null
			this.order_state = null
			this.type_state = null
			this.value_state = null

			this.data = {
				
				name : null,
				order : null,
				type : null,
				value : null,

			}
		},

		execute()
		{
			api.call(this, "cadastral_corrections", "get_many", { query : { cost_evaluation : this.id } },
				response =>
				{
					var existed_orders = []
					var orders = []

					response.data.forEach(cor => existed_orders.push(cor.order))

					for(let v = 1; v < 20; v++)
					{
						if(existed_orders.findIndex(order => order == v) < 0)
							orders.push(v)
					}

					this.orders = orders

					this.$refs.modal.execute()
				})
		},

		submit()
		{
			this.data.cost_evaluation = this.id
			this.data.order = Number(this.data.order)
			this.data.value = Number(this.data.value)

			api.call(this, "cadastral_corrections", "add", { data : this.data }, () => this.$emit("need_refresh"))
		},
	}
}

</script>


